import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, Box, Typography, Chip, Button } from '@mui/material';
import { Visibility, LocationOn } from '@mui/icons-material';

interface Props {
  profile: {
    athleteUuid: string;
    summary: string;
    topStrengths: string[];
    workStyle: string;
    prefecture: string;
    competitionPriority: string;
    aptitudeAreas: string[];
    keywords: string[];
  };
}

const ProfileSearchCard: React.FC<Props> = ({ profile }) => {
  const navigate = useNavigate();

  return (
    <Card sx={{ height: '100%', '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' } }}>
      <CardContent sx={{ p: 3 }}>
        <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6, color: '#333' }}>
          {profile.summary}
        </Typography>

        {/* 強み */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>
            強み
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {profile.topStrengths.slice(0, 3).map((s, i) => (
              <Chip key={i} label={s} size="small" color="success" variant="outlined" />
            ))}
          </Box>
        </Box>

        {/* メタ情報 */}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
          {profile.prefecture && (
            <Chip icon={<LocationOn />} label={profile.prefecture} size="small" variant="outlined" />
          )}
          {profile.workStyle && (
            <Chip label={profile.workStyle} size="small" variant="outlined" />
          )}
        </Box>

        {/* キーワード */}
        {profile.keywords.length > 0 && (
          <Box sx={{ mb: 2, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {profile.keywords.filter(Boolean).map((kw, i) => (
              <Chip key={i} label={`#${kw}`} size="small" sx={{ fontSize: '0.75rem' }} />
            ))}
          </Box>
        )}

        <Button
          variant="outlined"
          size="small"
          startIcon={<Visibility />}
          onClick={() => navigate(`/company/profile/${profile.athleteUuid}`)}
          fullWidth
        >
          詳細を見る
        </Button>
      </CardContent>
    </Card>
  );
};

export default ProfileSearchCard;
